import React from "react";

import Header from '../../header';
import Footer from '../../footer';

import Photo from '../../images/camps/prazdninove_chytani.jpg';

export default class PrazdninoveChytani extends React.Component {

  render() {
    return (<div>
            <Header />
		        <div className="view textArticle camps">

              <div className="indent">
                <img src={Photo} alt="J4K" />
              </div>

              <p>
              Kdy je správný čas zlepšovat své dovednosti, budovat lásku ke sportu a plnit si své sny? Přeci vždycky!:) Prázdninové chytání v našem stylu: šílení, chytání a zlepšování se.
              </p>

              <p>
              Přijď si s námi užít další akci. A pokud jsi ještě nikde nebyl/a, pojď si to očuchat a my ti s radostí poskytneme místo v brankářské rodině :)). Určitě nebudeš litovat a třeba z toho vznikne pouto na celý život (y).
              </p>

              <p>
              A kde jinde nachystat formu do další sezóny, než na hřišti!
              </p>

              <p>
              Vidíme se <b>21.8. 2025 na hřišti v Lukách nad Jihlavou.</b>
              </p>

              <p>
              Sraz v 9:00, konec 15:00.
              </p>

              <p>
              <b>  Cena: 900,-</b>
              </p>

              <p>
              - oběd, pitný režim, svačina, tréninky dovedností s profesionálními trenéry a zábava.
              </p>

              <p>
              Těšíme se :)
              </p>

              <p>
                <h4> <a href='https://just4keepers.dtap.cz/register/?link=49'>Přihláška tady</a></h4>
              </p>
            </div>

            <Footer />
      </div>
    );
  }

}
